<div class="container padding-top padding-bottom">
  <md-card>
    <div class="row padding-bottom">
      <div class="col-md-12">
        <button class="btn btn-primary"
                color="primary"
                (click)="goBack()">Go Back</button>
      </div>
      <div class="col-md-12 text-center">
        <img src="{{ (client | async)?.logoUrl }}"
             class="logo"
             alt="">
        <h1>{{ (client | async)?.name}}</h1>
        <h3><b>{{ (location | async)?.name}}</b></h3>
        <p></p>
      </div>
    </div>

    <div *ngIf="locationData?.moveInContractType == 'helloSign'"
         class="row padding-bottom">
      <div class="col-md-4 col-md-offset-4">
        <md-slide-toggle color="primary"
                         [(ngModel)]="formData.hasSeparateInsuranceLease">Separate insuance lease
        </md-slide-toggle>
      </div>
      <div *ngIf="formData.hasSeparateInsuranceLease"
           class="col-md-4 col-md-offset-4">
        <h4>HelloSign Lease Template w/Insurance ID</h4>
        <input type="text"
               *ngIf="formData"
               [(ngModel)]="formData.helloSignInsuranceTemplateId"
               pInputText
               class="full-width">
      </div>
      <div class="col-md-4 col-md-offset-4">
        <h4>HelloSign Lease Template ID</h4>
        <input type="text"
               *ngIf="formData"
               [(ngModel)]="formData.helloSignTemplateId"
               pInputText
               class="full-width">
      </div>
      <div class="col-md-12 sm-padding-top margin-bottom">
        <button class="btn btn-primary"
                color="primary"
                (click)="updateForm()"
                style="margin-top: -20px;float: right;margin: 0 10px;">Save Move In Lease</button>
        <button *ngIf="formData.hasSeparateInsuranceLease"
                class="btn btn-accent"
                color="primary"
                (click)="testForm(true)"
                style="margin-top: -20px;float: right;margin: 0 10px;">Test Insurance Lease</button>
        <button class="btn btn-accent"
                color="primary"
                (click)="testForm()"
                style="margin-top: -20px;float: right;margin: 0 10px;">Test Lease</button>
      </div>
    </div>


    <ng-container *ngIf="locationData?.moveInContractType == 'pugSign'">
      <div class="row padding-bottom">
        <div class="col-md-4 col-md-offset-4">
          <h4>Name</h4>
          <input type="text"
                 *ngIf="formData"
                 [(ngModel)]="formData.name"
                 pInputText
                 class="full-width">
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 sm-padding-top margin-bottom">
          <h4>Move In Lease</h4>
          <button class="btn btn-primary"
                  color="primary"
                  (click)="updateForm()"
                  style="margin-top: -20px;float: right;">Save Lease</button>
          <br>
          <br>
          <div id="froalaEditor"
               (froalaInit)="initialize($event)"
               [froalaEditor]="options"
               [(froalaModel)]="formData.formHtml"></div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 margin-bottom data-table">
          <h4>Move In Forms</h4>
          <div class="ui-widget-header"
               style="padding:4px 10px;border-bottom: 0 none">
            <i class="fa fa-search"
               style="margin:4px 4px 0 0"></i>
            <input #moveInSearch
                   type="text"
                   pInputText
                   placeholder="Search"
                   style="width: 250px !important;">
          </div>
          <p-dataTable [value]="allForms | async"
                       [loading]="loading"
                       scrollable="true"
                       scrollHeight="250px"
                       [globalFilter]="moveInSearch"
                       #moveInFormsTable
                       [(selection)]="locationData.moveInContract">
            <p-column [style]="{'width':'38px'}"
                      selectionMode="multiple"></p-column>
            <p-column field="name"
                      header="Name"
                      [sortable]="true"></p-column>
            <p-column field="categoryName"
                      header="Category"
                      [sortable]="true"></p-column>
            <p-column field="availableAtMoveIn"
                      header="Available At Move In"
                      [sortable]="true"></p-column>
            <p-column field="isPrintPreview"
                      header="Is Print Preview"
                      [sortable]="true"></p-column>
            <p-column field="formRtf"
                      header="RTF"
                      [sortable]="true">
              <ng-template let-col
                           let-car="rowData"
                           pTemplate="body">
                <div *ngIf="car['formRtf'] && car['formRtf'] != 'none'">Y</div>

              </ng-template>
            </p-column>
            <p-column field="formHtml"
                      header="HTML"
                      [sortable]="true">
              <ng-template let-col
                           let-car="rowData"
                           pTemplate="body">
                <!--{{car['formHtml']}}-->
                <div *ngIf="car['formHtml'] && car['formHtml'] != 'none'">Y</div>
              </ng-template>
            </p-column>
          </p-dataTable>
          <button class="btn btn-default"
                  (click)="updateClientForms(locationData.moveInContract, 'moveInContract')"
                  style="margin-top: 20px;">Set Editor HTML</button>
          <button class="btn btn-default"
                  (click)="updateClientFormsRtf(locationData.moveInContract, 'moveInContract')"
                  style="margin-top: 20px;">Set Editor RTF</button>
        </div>


      </div>
    </ng-container>

  </md-card>
</div>



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/forms-retrieve-settings/forms-retrieve-settings.component.html